import Slider from '@material-ui/lab/Slider';
import { navigate } from '@reach/router';

import React, { Component } from 'react';
import AvatarEditor from 'react-avatar-editor';

import Button from '../../../../components/Button';
import { IAvatarActions } from '../../../../store/avatar/actions';
import { IAvatarStore } from '../../../../store/avatar/store';
import { IProfileActions } from '../../../../store/user/actions';
import { IUserStore } from '../../../../store/user/store';

import { PX } from '../../../../contrib/ui';
import { withContext } from '../../../../contrib/utils';

import { INotificationsActions } from '../../../../store/notification/actions';
import {
  ILocalMessageState,
  IMessageNotification,
  initialLocalMessageState
} from '../../../../store/notification/store';

interface IProps {
  actions: {
    avatar: IAvatarActions;
    notifications: INotificationsActions;
    user: IProfileActions;
  };
  avatar: IAvatarStore;
  user: IUserStore;
}

interface IState {
  message: ILocalMessageState;
  zoom: number;
}

export class EditPictureComponent extends Component<IProps, IState> {
  public editorRef: any;
  constructor(props: IProps) {
    super(props);

    props.actions.user.getOrRetrieve();

    this.state = {
      message: initialLocalMessageState,
      zoom: 1
    };

    this.editorRef = React.createRef();
    this.handleZoom = this.handleZoom.bind(this);
    this.back = this.back.bind(this);
    this.save = this.save.bind(this);

    if (!props.avatar.base64) {
      navigate(
        location.pathname === `/staff/profile/edit-picture`
          ? '/staff/profile/select-picture'
          : '/profile/select-picture'
      );
    }
  }

  public handleZoom(_: any, zoom: number): void {
    this.setState({ zoom });
  }

  public async save(): Promise<any> {
    const { actions } = this.props;

    const image = this.editorRef.current.getImage().toDataURL();
    const response = await actions.user.updatePicture(image);

    if (response.errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: response.errors.profile.msg,
        type: 'error'
      } as unknown) as IMessageNotification);
      setTimeout(
        () =>
          navigate(
            location.pathname === `/staff/profile/edit-picture`
              ? '/staff/profile/settings'
              : '/profile/settings'
          ),
        4000
      );
    } else {
      navigate(
        location.pathname === `/staff/profile/edit-picture`
          ? '/staff/profile/settings'
          : '/profile/settings'
      );
    }
  }

  public back(): void {
    navigate(
      location.pathname === `/staff/profile/edit-picture`
        ? '/staff/profile/select-picture'
        : '/profile/select-picture'
    );
  }

  public render(): JSX.Element {
    // const { user } = this.props;
    const { zoom } = this.state;
    const { base64 } = this.props.avatar;

    return (
      <div className="home account-settings wrapper">
        <div className="edit-picture-wrapper">
          <h2 className="account-title">EDIT PICTURE</h2>

          <div className="picture-editor">
            <div className="filter" style={{ backgroundImage: base64 }}>
              <div className="mask" />
            </div>
            <AvatarEditor
              ref={this.editorRef}
              image={base64}
              width={220 * PX}
              height={220 * PX}
              border={0}
              color={[55, 55, 55, 0.7]} // RGBA
              scale={zoom}
              rotate={0}
              borderRadius={110 * PX}
            />
          </div>

          <div className="zoom-title">ZOOM</div>
          <div className="slider-wrapper">
            <Slider
              classes={{
                track: 'zoom-slider-track',
                trackAfter: 'zoom-slider-track-after',
                trackBefore: 'zoom-slider-track-before'
              }}
              value={zoom}
              className="zoom-slider"
              aria-labelledby="label"
              onChange={this.handleZoom}
              min={1}
              max={3}
            />
            <div className="radius-left">
              <div className="hack" />
            </div>
            <div className="radius-right">
              <div className="hack" />
            </div>
          </div>

          <Button
            id="next"
            onClick={this.save}
            variant="contained"
            color="primary"
            fullWidth={true}
            className="button button-shadow "
          >
            SAVE EDITS
          </Button>
          <Button
            id="back"
            onClick={this.back}
            variant="outlined"
            color="primary"
            fullWidth={true}
            className="button"
          >
            CHANGE PICTURE
          </Button>
        </div>
      </div>
    );
  }
}

const EditPicture = withContext(EditPictureComponent, 'avatar', 'user');

export { EditPicture };
